import { Flex } from "antd"
import BookingDetails from "ui/Booking/Details"
import IconWithBg from "ui/IconWithBg"
import { LeftOutlined } from "@ant-design/icons"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch,useSelector } from "react-redux"
import { getClientBookingDetails } from "store/bookings"
import { useEffect } from "react"

const BookingDetailsPage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { id } = useParams()
      const { data } = useSelector((store) => store?.bookings?.clientBookingDetails) || {}
  const handleBackToBookings = () => {
    navigate(-1)
  }

  useEffect(() => {
    dispatch(getClientBookingDetails(id))
  }, [id, dispatch])

  return (
    <Flex vertical className="mt-m">
      <IconWithBg icon={<LeftOutlined />} onClick={handleBackToBookings} />
      <BookingDetails isShowTitle={false} uuid={data?.uuid} />
    </Flex>
  )
}

export default BookingDetailsPage
